import { breadcrumbsMutations } from "../mutation-types";

export default {
	namespaced: true,

	state: {
		breadcrumbs: [],
		details: null
	},

	getters: {
		current( store ) {
			if ( store.breadcrumbs.length ) {
				return store.breadcrumbs[store.breadcrumbs.length - 1];
			}

			return "";
		}
	},

	actions: {
		clear( { commit } ) {
			commit( breadcrumbsMutations.CLEAR );
		},
		clearDetails( { commit } ) {
			commit( breadcrumbsMutations.CLEAR_DETAILS );
		},
		set( { commit }, breadcrumbs = [] ) {
			commit( breadcrumbsMutations.SET, breadcrumbs );
		},
		setDetails( { commit }, details = null ) {
			commit( breadcrumbsMutations.SET_DETAILS, details );
		}
	},

	mutations: {
		[breadcrumbsMutations.CLEAR]( store ) {
			store.breadcrumbs = [];
		},
		[breadcrumbsMutations.CLEAR_DETAILS]( store ) {
			store.details = null;
		},
		[breadcrumbsMutations.SET]( store, val ) {
			store.breadcrumbs = val;
		},
		[breadcrumbsMutations.SET_DETAILS]( store, val ) {
			store.details = val;
		}
	}
};
